import PropTypes from 'prop-types';
import { experimentalStyled } from '@mui/material/styles';

const LabelRoot = experimentalStyled('span')(({ theme, color }) => {
  const backgroundColor = theme.palette[color].main;
  const themeColor = theme.palette[color].contrastText;

  return {
    height: '28px',
    alignItems: 'center',
    backgroundColor,
    borderRadius: theme.shape.borderRadius,
    color: themeColor,
    cursor: 'default',
    display: 'inline-flex',
    flexGrow: 0,
    flexShrink: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(11),
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: 'center',
    letterSpacing: 0.5,
    minWidth: 20,
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    whiteSpace: 'nowrap',
  };
});

const Label = (props) => {
  const { color = 'primary', children, ...other } = props;

  return (
    <LabelRoot color={color} {...other}>
      {children}
    </LabelRoot>
  );
};

Label.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'error',
    'warning',
    'success',
  ]),
};

export default Label;
